import { Injectable } from '@angular/core';
import { DOCUMENT_TYPES } from './document-types';

@Injectable({
  providedIn: 'root'
})
export class DocumentFormatterService {

  private currentDocumentType: typeof DOCUMENT_TYPES[0] | null = null;

  /**
   * Aplica el formato según la máscara definida
   * @param value - Valor actual del input
   * @param mask - Máscara a aplicar
   * @returns String formateado
   */
  applyMask(value: string, mask: string, documentId: string): string {
    let result = '';
    let valueIndex = 0;

    switch (documentId) {
      case 'dni':
        if (value.length === 0) {
          value = '0';
        } else if (!value.startsWith('0')) {
          value = '0' + value.replace(/^0+/, ''); // Evita múltiples ceros
        }
        break;
      case 'cpj':
        if (value.length === 0) {
          value = '3';
        } else if (!value.startsWith('3')) {
          value = '3' + value.substring(1);
        }
        break;
      case 'enr':
        if (value.length === 0) {
          value = '9';
        } else if (!value.startsWith('9')) {
          value = '9' + value;
        }
        break;
      case 'dimex':
        if (value.length === 0) {
          value = '1';
        } else if (!value.startsWith('1')) {
          value = '1' + value.substring(1);
        }
        break;
      case 'didi':
        if (value.length === 0) {
          value = '5';
        } else if (!value.startsWith('5')) {
          value = '5' + value.substring(1);
        }
        break;
    }
    for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
      const maskChar = mask[i];
      const valueChar = value[valueIndex];

      switch (maskChar) {
        case '0':
          if (/\d/.test(valueChar)) {
            result += valueChar;
            valueIndex++;
          }
          break;
        case 'A':
          if (documentId === 'enr') {
            if (/[a-zA-Z0-9]/.test(valueChar)) {
              result += valueChar.toUpperCase();
              valueIndex++;
            }
          } else {
            if (/[a-zA-Z]/.test(valueChar)) {
              result += valueChar.toUpperCase();
              valueIndex++;
            }
          }
          break;
        case '9':
          if (/[a-zA-Z0-9]/.test(valueChar)) {
            result += valueChar;
            valueIndex++;
          }
          break;
        default:
          result += maskChar;
          if (valueChar === maskChar) valueIndex++;
      }
    }

    return result;
  }

  /**
   * Valida el valor contra el patrón definido
   * @param value - Valor a validar
   * @param pattern - Patrón RegExp
   * @returns Boolean indicando si es válido
   */
  validatePattern(value: string, pattern: RegExp): boolean {
    return pattern.test(value);
  }
}
